import styled from "styled-components";

export const ScoresheetStack = styled.div.attrs({ className: "space-y-5" })``;

export const ScoresheetGrid = styled.div.attrs({
  className: "grid gap-4 xl:grid-cols-[minmax(0,1.35fr)_minmax(320px,0.95fr)]",
})``;

export const ScoresheetColumn = styled.div.attrs({ className: "space-y-4" })``;

export const ScoresheetCard = styled.section.attrs({
  className:
    "rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] p-4 shadow-[0_16px_24px_rgba(0,0,0,0.18)]",
})``;

export const ScoresheetCardHeader = styled.div.attrs({ className: "flex flex-wrap items-start justify-between gap-3" })``;

export const ScoresheetEyebrow = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const ScoresheetTitle = styled.h3.attrs({ className: "mt-1 text-lg font-semibold text-[var(--brand-ink)]" })``;

export const ScoresheetBodyText = styled.p.attrs({ className: "mt-2 text-sm leading-6 text-[var(--brand-muted)]" })``;

export const ScoreBadgeRow = styled.div.attrs({ className: "grid gap-3 md:grid-cols-2" })``;

export const ScoreBadge = styled.div.attrs({
  className:
    "rounded-[22px] border border-[rgba(255,255,255,0.08)] bg-[rgba(8,12,18,0.55)] px-4 py-4",
})``;

export const ScoreBadgeLabel = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.16em] text-[var(--brand-muted)]",
})``;

export const ScoreBadgeValue = styled.p.attrs({
  className: "mt-2 text-3xl font-semibold tracking-tight text-[var(--brand-ink)]",
})``;

export const ScoreBadgeMeta = styled.p.attrs({
  className: "mt-2 text-xs text-[var(--brand-muted)]",
})``;

export const SegmentedRow = styled.div.attrs({ className: "flex flex-wrap gap-2" })``;

export const SegmentButton = styled.button.attrs({ type: "button" })<{ $active?: boolean }>`
  border: 1px solid
    ${({ $active }) => ($active ? "rgba(240, 191, 86, 0.35)" : "rgba(255, 255, 255, 0.08)")};
  background: ${({ $active }) =>
    $active ? "rgba(240, 191, 86, 0.18)" : "rgba(255, 255, 255, 0.04)"};
  color: ${({ $active }) => ($active ? "var(--brand-highlight)" : "var(--brand-ink)")};
  border-radius: 999px;
  padding: 0.7rem 1rem;
  font-size: 0.78rem;
  font-weight: 600;
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, color 160ms ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(240, 191, 86, 0.28);
  }
`;

export const InlineFormGrid = styled.div.attrs({ className: "grid gap-3 md:grid-cols-2" })``;

export const InlineField = styled.label.attrs({ className: "block" })``;

export const InlineLabel = styled.span.attrs({
  className: "mb-2 block text-xs font-medium uppercase tracking-[0.14em] text-[var(--brand-muted)]",
})``;

export const InlineInput = styled.input.attrs({
  className:
    "w-full rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm text-[var(--brand-ink)] outline-none transition focus:border-[var(--brand-highlight)] focus:ring-2 focus:ring-[rgba(240,191,86,0.18)]",
})``;

export const InlineTextarea = styled.textarea.attrs({
  className:
    "w-full rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm text-[var(--brand-ink)] outline-none transition focus:border-[var(--brand-highlight)] focus:ring-2 focus:ring-[rgba(240,191,86,0.18)]",
})``;

export const QuickActionsGrid = styled.div.attrs({ className: "grid gap-2 sm:grid-cols-2 xl:grid-cols-3" })``;

export const QuickActionButton = styled.button.attrs({ type: "button" })`
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(8, 12, 18, 0.55);
  color: var(--brand-ink);
  border-radius: 18px;
  padding: 0.95rem 1rem;
  text-align: left;
  font-size: 0.92rem;
  font-weight: 600;
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(240, 191, 86, 0.28);
    background: rgba(240, 191, 86, 0.08);
  }
`;

export const ActionButtonRow = styled.div.attrs({ className: "flex flex-wrap gap-2" })``;

export const PrimaryActionButton = styled.button.attrs({ type: "button" })`
  border: 1px solid rgba(240, 191, 86, 0.32);
  background: var(--brand-highlight);
  color: #20160a;
  border-radius: 999px;
  padding: 0.78rem 1.1rem;
  font-size: 0.85rem;
  font-weight: 700;
  transition: transform 160ms ease, filter 160ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.03);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryActionButton = styled.button.attrs({ type: "button" })`
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: var(--brand-ink);
  border-radius: 999px;
  padding: 0.78rem 1.1rem;
  font-size: 0.85rem;
  font-weight: 600;
  transition: transform 160ms ease, border-color 160ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    border-color: rgba(240, 191, 86, 0.24);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const TeamScoreGrid = styled.div.attrs({ className: "grid gap-4 lg:grid-cols-2" })``;

export const TeamScoreCard = styled.div.attrs({
  className: "rounded-[22px] border border-[rgba(255,255,255,0.08)] bg-[rgba(8,12,18,0.55)] p-4",
})``;

export const TeamScoreHeader = styled.div.attrs({ className: "flex items-center justify-between gap-3" })``;

export const TeamScoreName = styled.h4.attrs({ className: "text-base font-semibold text-[var(--brand-ink)]" })``;

export const TeamScoreSubtext = styled.p.attrs({ className: "text-xs text-[var(--brand-muted)]" })``;

export const TeamFieldGrid = styled.div.attrs({ className: "mt-4 grid gap-3" })``;

export const TimelineStack = styled.div.attrs({ className: "space-y-3" })``;

export const TimelineItem = styled.div.attrs({
  className: "rounded-[18px] border border-[rgba(255,255,255,0.08)] bg-[rgba(8,12,18,0.55)] px-4 py-3",
})``;

export const TimelineHeader = styled.div.attrs({ className: "flex flex-wrap items-center justify-between gap-2" })``;

export const TimelineTitle = styled.p.attrs({ className: "text-sm font-semibold text-[var(--brand-ink)]" })``;

export const TimelineMeta = styled.p.attrs({ className: "text-xs text-[var(--brand-muted)]" })``;

export const TimelineNote = styled.p.attrs({ className: "mt-2 text-sm leading-6 text-[var(--brand-muted)]" })``;
